import { createBrowserHistory } from 'history';
export const createHistory = (config) => createBrowserHistory({ forceRefresh: config.forceRefreshRouting });
//# sourceMappingURL=createHistory.js.map